import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { UserCreatePage } from "~/domain/common";

export function LqsUserCreatePage() {
  return <UserCreatePage breadcrumbs={<DataStoreBreadcrumbs />} />;
}
